import React from 'react';
import styles from './index.module.css';
import whatsappIcon from '../../assets/whatsapp-icon.webp';
import whatsappBck from '../../assets/whatsapp-bg.webp';

const WhatsappSection = () => {
    return (
        <section className={styles.sectionWhatsapp} style={{ backgroundImage: `url(${whatsappBck})`, backgroundSize: 'cover' }}>
            <div className="container-lg text-center flex flexCol alignCenter">
                <h2>Cotizá tu Alarma por Whatsapp</h2>
                <a href="https://wa.me/541126597907" target="_blank" rel="noopener noreferrer" className={styles.boton}>
                    <img src={whatsappIcon} alt="WhatsApp" loading="lazy" decoding="async" />
                    Consultar por WhatsApp
                </a>
                <p>
                    Te damos asesoramiento por especialistas en seguridad de forma
                    GRATUITA
                </p>
            </div>
        </section>
    );
};

export default WhatsappSection;
